"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const auth = __importStar(require("../../lib/Auth"));
const UserInfo_1 = require("../../lib/UserInfo");
exports.AuthProvider = ({ children }) => {
    const auth = useProvideAuth();
    return react_1.default.createElement(exports.AuthContext.Provider, { value: auth }, children);
};
exports.AuthContext = react_1.createContext({});
exports.useAuth = () => {
    return react_1.useContext(exports.AuthContext);
};
function useProvideAuth() {
    const [isAuthenticated, setIsAuthenticated] = react_1.useState(false);
    const [isChecking, setIsChecking] = react_1.useState(false);
    const login = async () => {
        setIsChecking(true);
        try {
            await auth.login();
            await acquireTokens();
        }
        catch (e) {
            console.error(e);
            setIsAuthenticated(false);
        }
    };
    const logout = () => {
        auth.logout();
        setIsAuthenticated(false);
    };
    const getProfile = UserInfo_1.getProfileInfo;
    const acquireTokens = async () => {
        setIsChecking(true);
        try {
            await auth.aquireToken('graphApi');
            await auth.aquireToken('functionApi');
            setIsAuthenticated(true);
        }
        catch (e) {
            setIsAuthenticated(false);
        }
        finally {
            setIsChecking(false);
        }
    };
    react_1.useEffect(() => {
        if (!isAuthenticated) {
            acquireTokens();
        }
    }, []);
    return {
        isAuthenticated,
        isChecking,
        login,
        logout,
        getProfile
    };
}
